export const DateBodyTemplate = (rowData: any) => {
  const date = new Date(rowData.createDate).toLocaleDateString() || "";
  return (
    <div className="flex align-items-center text-900">
      <i className="pi pi-calendar-plus mr-2 text-color-secondary"></i>
      {date}
    </div>
  );
};
